/* ==========================================================================
   NODI, customer ordering assistant for dtftransfers.com
   --------------------------------------------------------------------------
   Customer-facing sibling of the reseller NODI on sell.dtftransfers.com.
   Runs on the four upload PDPs (dtf-imgix, uv-by-size-imgix, dtf-gang-imgix,
   uv-gang-imgix). Guided agent, zero dependencies:

     • context-aware order walkthroughs per page type, with "Show me"
       actions that scroll to + pulse the real UI
     • live pricing answers, by-size tiers are read from the page's own
       cumulative-discounts card, never hardcoded
     • reseller pitch card for sell.dtftransfers.com

   Backend hook: define `window.NODI_BACKEND = { send(text) -> Promise<html> }`
   and typed messages route there instead of the keyword router, drop-in
   upgrade path to the real NODI agent service later.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__nodiInit) return;
  window.__nodiInit = true;

  var bc = document.body.className;
  var CTX =
    /template-product-dtf-gang-imgix/.test(bc) ? 'dtf-gang' :
    /template-product-uv-gang-imgix/.test(bc)  ? 'uv-gang'  :
    /template-product-uv-by-size/.test(bc)     ? 'uv-size'  :
    /template-product-dtf-imgix/.test(bc)      ? 'dtf-size' :
    'other';
  var IS_GANG = CTX === 'dtf-gang' || CTX === 'uv-gang';
  var IS_UV   = CTX === 'uv-gang' || CTX === 'uv-size';
  var IS_PDP  = CTX !== 'other';
  var PRODUCT_NAME = !IS_PDP ? 'DTF Transfers'
                   : IS_GANG ? (IS_UV ? 'UV DTF Gang Sheets' : 'DTF Gang Sheets')
                             : (IS_UV ? 'UV DTF Stickers by size' : 'DTF Transfers by size');
  var SELL_URL = 'https://sell.dtftransfers.com';
  var OFFSITE = /(^|\.)sell\.dtftransfers\.com$|(^|\.)ninjaondemand\.com$|amplifyapp\.com$/.test(location.hostname);
  var SITE = OFFSITE ? 'https://dtftransfers.com' : ''; // prefix for on-site /pages/* links

  var GLYPH = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6.5 17.5c-2.5 0-4.5-2-4.5-4.4 0-2.2 1.7-4 3.8-4.4C6.4 6 8.9 4 11.9 4c3.2 0 5.9 2.3 6.4 5.4 2 .3 3.7 2 3.7 4.1 0 2.2-1.9 4-4.2 4H6.5z" fill="#fff"/></svg>';
  var SEND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>';
  var PEN  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>';
  var EXPAND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"/><path d="M9 21H3v-6"/><path d="M21 3l-7 7"/><path d="M3 21l7-7"/></svg>';
  var CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
  var XICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var GRID = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="4" y="4" width="6" height="6" rx="1.4"/><rect x="14" y="4" width="6" height="6" rx="1.4"/><rect x="4" y="14" width="6" height="6" rx="1.4"/><rect x="14" y="14" width="6" height="6" rx="1.4"/></svg>';
  var CLIP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.4 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66L9.4 17.4a2 2 0 01-2.83-2.83l8.49-8.48"/></svg>';
  var BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 016 0"/></svg>';

  /* brand mark: circle-crop the left edge of the header wordmark SVG */
  var headerLogo = document.querySelector('.dtfhd-logo-img');
  var LOGO_SRC = headerLogo ? headerLogo.src : '';
  function ava(size) {
    if (LOGO_SRC) return '<img class="nodi-ava" src="' + LOGO_SRC + '" alt="" width="' + size + '" height="' + size + '" style="width:' + size + 'px;height:' + size + 'px">';
    return '<span class="nodi-ava" style="width:' + size + 'px;height:' + size + 'px;background:#FF394C;display:flex;align-items:center;justify-content:center">' + GLYPH + '</span>';
  }

  /* ---------- DOM scaffold ---------- */
  var CHAT_GLYPH = '<svg class="nodi-launcher__chat" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 4.5c-4.6 0-8.3 3.1-8.3 7 0 1.6.6 3 1.7 4.2-.2.9-.7 2.1-1.5 3 1.6-.1 3-.7 4-1.3 1.2.5 2.6.8 4.1.8 4.6 0 8.3-3.1 8.3-6.7s-3.7-7-8.3-7z" fill="#fff"/><circle cx="8.6" cy="11.5" r="1.05" fill="#FF394C"/><circle cx="12" cy="11.5" r="1.05" fill="#FF394C"/><circle cx="15.4" cy="11.5" r="1.05" fill="#FF394C"/></svg>';
  var MIN_GLYPH = '<svg class="nodi-launcher__min" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 10l6 6 6-6"/></svg>';
  var launcher = document.createElement('button');
  launcher.type = 'button';
  launcher.className = 'nodi-launcher';
  launcher.setAttribute('aria-label', 'Chat with Nodi');
  launcher.innerHTML = CHAT_GLYPH + MIN_GLYPH;

  var panel = document.createElement('div');
  panel.className = 'nodi-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'Nodi assistant');
  panel.innerHTML =
    '<div class="nodi-head">' +
      ava(46) +
      '<span class="nodi-head__titles">' +
        '<span class="nodi-head__name">Nodi <span class="nodi-head__dot" aria-label="online"></span></span>' +
        '<div class="nodi-head__sub">' + (IS_PDP ? 'DTF Transfers' : 'dtftransfers.com') + '</div>' +
      '</span>' +
      '<button type="button" class="nodi-head__newchat" data-nodi-new>' + PEN + '<span>New chat</span></button>' +
      '<button type="button" class="nodi-icn" data-nodi-max aria-label="Expand">' + EXPAND + '</button>' +
      '<button type="button" class="nodi-icn" data-nodi-min aria-label="Minimize">' + CHEV + '</button>' +
      '<button type="button" class="nodi-icn" data-nodi-close aria-label="Close">' + XICON + '</button>' +
      '<div class="nodi-newpop" data-nodi-newpop>' +
        '<div class="nodi-newpop__title">Start a new chat?</div>' +
        '<div class="nodi-newpop__body" data-nodi-newpop-body></div>' +
        '<div class="nodi-newpop__row">' +
          '<button type="button" class="nodi-newpop__go" data-nodi-newpop-go>Start new</button>' +
          '<button type="button" class="nodi-newpop__cancel" data-nodi-newpop-cancel>Cancel</button>' +
        '</div>' +
      '</div>' +
    '</div>' +
    '<div class="nodi-cartbar" data-nodi-cart>' + BAG + '<span data-nodi-cart-text>Your cart is empty</span><a class="nodi-cartbar__link" data-nodi-cart-link href="/cart">View cart</a></div>' +
    '<div class="nodi-body" data-nodi-body></div>' +
    '<div class="nodi-attachbar" data-nodi-attachbar></div>' +
    '<div class="nodi-foot" style="position:relative">' +
      '<div class="nodi-quickmenu" data-nodi-quickmenu></div>' +
      '<button type="button" class="nodi-foot__tool" data-nodi-quick aria-label="Quick actions">' + GRID + '</button>' +
      '<button type="button" class="nodi-foot__tool" data-nodi-attach aria-label="Upload artwork">' + CLIP + '</button>' +
      '<input type="text" placeholder="Message Nodi…" aria-label="Message Nodi" data-nodi-input>' +
      '<button type="button" class="nodi-foot__send" aria-label="Send" data-nodi-send>' + SEND + '</button>' +
    '</div>';

  document.body.appendChild(launcher);
  document.body.appendChild(panel);

  var body = panel.querySelector('[data-nodi-body]');
  var input = panel.querySelector('[data-nodi-input]');

  /* ---------- cart strip ---------- */
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var bar = panel.querySelector('[data-nodi-cart]');
      var txt = panel.querySelector('[data-nodi-cart-text]');
      if (!cart.item_count) {
        bar.classList.remove('has-items');
        txt.textContent = 'Your cart is empty';
      } else {
        bar.classList.add('has-items');
        txt.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' in your cart \u00b7 ' + money(cart.total_price);
      }
    }).catch(function () {});
  }

  /* ---------- session persistence (Justin 2026-07-27) ----------
     The conversation survives navigation (Nodi hands off between product
     pages), reloads, and every tab/window of this browser session, cleared
     only by "New chat". Cross-tab updates arrive via the storage event.
     NOTE: a truly cross-BROWSER session needs the server side, wire
     window.NODI_BACKEND and this store becomes the local cache for it. */
  var LS_KEY = 'nodi-chat-v5'; // v5 2026-08-04: buy-direct product link added; v4 logs replay retired copy
  var TTL_MS = 24 * 60 * 60 * 1000;
  var log = [];          /* [{r:'bot'|'user'|'card', h|t}] */
  var restoring = false;

  function save() {
    if (restoring) return;
    try {
      localStorage.setItem(LS_KEY, JSON.stringify({
        log: log.slice(-60),
        staged: staged ? { imgix: staged.imgix, bgRemove: staged.bgRemove, upscale: staged.upscale, name: staged.file ? staged.file.name : '' } : null,
        ts: nowMs()
      }));
    } catch (e) {}
  }
  function nowMs() { return new Date().getTime(); }
  function readSaved() {
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (!d || !d.log || !d.log.length) return null;
      if (nowMs() - (d.ts || 0) > TTL_MS) { localStorage.removeItem(LS_KEY); return null; }
      return d;
    } catch (e) { return null; }
  }
  function clearSaved() {
    log = [];
    staged = null;
    previewMsg = null;
    try { localStorage.removeItem(LS_KEY); } catch (e) {}
  }

  /* ---------- message helpers ---------- */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function scrollBottom() { body.scrollTop = body.scrollHeight; }

  function bot(html, noLog) {
    var row = document.createElement('div');
    row.className = 'nodi-row';
    row.innerHTML = ava(28);
    var el = document.createElement('div');
    el.className = 'nodi-msg nodi-msg--bot';
    el.innerHTML = html;
    row.appendChild(el);
    body.appendChild(row);
    scrollBottom();
    if (!noLog && !restoring) { log.push({ r: 'bot', h: html }); save(); }
    return el;
  }
  function user(text) {
    var el = document.createElement('div');
    el.className = 'nodi-msg nodi-msg--user';
    el.textContent = text;
    body.appendChild(el);
    scrollBottom();
    if (!restoring) { log.push({ r: 'user', t: text }); save(); }
  }
  function chips(list) {
    var old = body.querySelector('.nodi-chips');
    if (old) old.remove();
    var wrap = document.createElement('div');
    wrap.className = 'nodi-chips';
    list.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nodi-chip';
      b.textContent = c.label;
      b.addEventListener('click', function () { user(c.label); c.go(); });
      wrap.appendChild(b);
    });
    body.appendChild(wrap);
    scrollBottom();
  }
  /* Pricing questions no longer open an in-chat calculator (Justin 2026-07-31): the home page's
     "How pricing works" sample cart is the real thing, so Nodi gives ONE worked example in text,
     the site's own published numbers, and sends them there. pricingCard() also stands in for
     old saved transcripts that recorded the retired calculator (r:'pcalc'). */
  function pricingCard() {
    var el = document.createElement('div');
    el.className = 'nodi-card';
    el.innerHTML =
      '<span class="nodi-card__eyebrow">How pricing works</span>' +
      '<span class="nodi-card__title">Pay wholesale. Sell at a margin you control.</span>' +
      '<span class="nodi-card__sub">Build a sample cart and watch your cost, sales price, and profit move as quantities climb.</span>' +
      '<a class="nodi-card__cta" href="' + SITE + '/#pricing">See how pricing works →</a>';
    body.appendChild(el);
    scrollBottom();
    if (!restoring) { log.push({ r: 'pcalc' }); save(); }
  }

  function marginFlow() {
    bot('Here is a real example from our pricing page: an <b>11" x 5" DTF transfer</b> at 50 pieces costs you about <b>$2.30 each</b> (30% off the $3.29 one-off price). Sell it at <b>$4.00</b> and you keep <b>$1.70 per piece</b>, about a <b>43% margin</b>. Blanks work the same way: a Gildan tee at <b>$2.91 wholesale</b> sold at $5.00 keeps you <b>$2.09</b>.');
    bot('Prefer to just buy from us directly? Same wholesale pricing: bulk discounts take <b>20% off at 15+</b> pieces, <b>30% off at 50+</b>, <b>40% off at 100+</b> and <b>50% off at 250+</b>, so the more you order the less each transfer costs. <a href="' + SITE + '/products/dtf-transfers">Buy DTF transfers</a> right here on the site.');
    pricingCard();
    chips([
      { label: 'How do I get started?', go: resellerEducationFlow },
      { label: 'I need print capacity', go: capacityFlow }
    ]);
  }

  function capacityCard() {
    var el = document.createElement('div');
    el.className = 'nodi-card';
    el.innerHTML =
      '<span class="nodi-card__eyebrow">Need print capacity</span>' +
      '<span class="nodi-card__title">Overflow production, on tap</span>' +
      '<span class="nodi-card__sub">Hand off the work you can’t get to. We print and blind-ship under your label at wholesale prices. No minimums, and customer service and reprints are built into the software.</span>' +
      '<a class="nodi-card__cta" href="' + SITE + '/pages/capacity">Learn more →</a>';
    body.appendChild(el);
    scrollBottom();
    if (!restoring) { log.push({ r: 'ccap' }); save(); }
  }
  function resellerCard() {
    var el = document.createElement('div');
    el.className = 'nodi-card';
    el.innerHTML =
      '<span class="nodi-card__eyebrow">Start your own store</span>' +
      '<span class="nodi-card__title">Sell DTF transfers under your own brand</span>' +
      '<span class="nodi-card__sub">dtftransfers.com gives you your own storefront with our full catalog: you set your prices and sell, we print, ship, and handle customer service for you. Your customers, your brand.</span>' +
      '<a class="nodi-card__cta" href="' + SITE + '/pages/storefronts">Learn more →</a>';
    body.appendChild(el);
    scrollBottom();
    if (!restoring) { log.push({ r: 'card' }); save(); }
  }

  /* animated working indicator (upload staging / art prep) */
  function working(label) {
    var el = document.createElement('div');
    el.className = 'nodi-working';
    el.innerHTML = '<span class="nodi-working__dots"><i></i><i></i><i></i></span><span>' + esc(label) + '</span>';
    body.appendChild(el);
    scrollBottom();
    return { done: function () { if (el.parentNode) el.parentNode.removeChild(el); } };
  }

  /* ---------- in-chat upload (parity with the reseller NODI) ---------- */
  var CLOUD = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6.5 17.5c-2.5 0-4.5-2-4.5-4.4 0-2.2 1.7-4 3.8-4.4C6.4 6 8.9 4 11.9 4c3.2 0 5.9 2.3 6.4 5.4 2 .3 3.7 2 3.7 4.1 0 2.2-1.9 4-4.2 4H6.5z" fill="#FF394C"/><path d="M12 15.5v-4.2m0 0l-1.8 1.7M12 11.3l1.8 1.7" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var ACCEPT = 'image/png,image/jpeg,image/tiff,image/svg+xml,application/pdf,application/postscript,image/vnd.adobe.photoshop,.png,.jpg,.jpeg,.svg,.pdf,.ai,.psd,.tif,.tiff';
  var nodiFile = document.createElement('input');
  nodiFile.type = 'file';
  nodiFile.accept = ACCEPT;
  nodiFile.style.display = 'none';
  document.body.appendChild(nodiFile);
  /* sell.dtftransfers.com parity: attaching does NOT send. The file stays
     pinned to the composer until the user sends, file + message go together. */
  var pendingFile = null;
  function setPending(file) {
    pendingFile = file;
    var bar = panel.querySelector('[data-nodi-attachbar]');
    var isImg = /^image\//.test(file.type);
    var thumb = isImg ? '<img src="' + URL.createObjectURL(file) + '" alt="">' : '<span class="nodi-attach-chip__icon">' + CLIP + '</span>';
    bar.innerHTML = '<span class="nodi-attach-chip">' + thumb +
      '<span class="nodi-attach-chip__name">' + esc(file.name) + '</span>' +
      '<button type="button" class="nodi-attach-chip__x" aria-label="Remove attachment">✕</button></span>';
    bar.classList.add('has-file');
    bar.querySelector('.nodi-attach-chip__x').addEventListener('click', clearPending);
    input.placeholder = 'Add a note about your file, then send…';
    input.focus();
  }
  function clearPending() {
    pendingFile = null;
    var bar = panel.querySelector('[data-nodi-attachbar]');
    bar.classList.remove('has-file');
    bar.innerHTML = '';
    input.placeholder = 'Message Nodi…';
  }
  nodiFile.addEventListener('change', function () {
    if (nodiFile.files && nodiFile.files[0]) { setPending(nodiFile.files[0]); nodiFile.value = ''; }
  });

  function pageFileInput() {
    return document.querySelector(IS_GANG ? '#fileInput' : '[data-bsv4-file-input]');
  }

  /* ---------- chat-side staging (Justin 2026-07-27) ----------
     Uploads land in the CHAT first: Nodi presigns to the same NOD pipeline
     the page engines use, previews the art in-chat, applies edits there,
     and only pushes to a product page once the customer picks DTF vs UV.
     Same product = pipe the File into this page's engine; other product =
     hand off via the ?file= flow every PDP already consumes. */
  var NODI_API = 'https://pan32vgek6.execute-api.us-east-1.amazonaws.com';
  var NODI_S3 = 'dtf-stores.s3.amazonaws.com';
  var NODI_IMGIX = 'dtf-store.imgix.net';
  var staged = null; /* { file, imgix, bgRemove, upscale } */

  function nodiPresign(file) {
    var ext = (file.name.split('.').pop() || '').toLowerCase();
    return fetch(NODI_API + '/upload-url', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ext: ext, type: file.type || 'application/octet-stream', size: file.size || 0 })
    }).then(function (r) {
      if (!r.ok) throw new Error('presign ' + r.status);
      return r.json();
    }).then(function (p) {
      if (!p || !p.url) throw new Error('presign unavailable');
      return fetch(p.url, { method: 'PUT', body: file }).then(function (r2) {
        if (!r2.ok) throw new Error('S3 PUT ' + r2.status);
        return 'https://' + NODI_IMGIX + '/' + (p.key || '');
      });
    });
  }

  function stagedPreviewSrc() {
    return staged.imgix + '?w=380&fit=max&auto=format' + (staged.bgRemove ? '&bg-remove=true' : '');
  }
  var previewMsg = null;
  function showStagedPreview(prepLabel) {
    var html = '<span class="nodi-prep' + (prepLabel ? ' is-loading' : '') + '" data-nodi-prep>' +
        '<img src="' + stagedPreviewSrc() + '" alt="Your design">' +
        '<span class="nodi-prep__veil">' +
          '<span class="nodi-working__dots nodi-prep__dots"><i></i><i></i><i></i></span>' +
          '<span class="nodi-prep__label">' + esc(prepLabel || '') + '</span></span>' +
      '</span>' +
      (staged.upscale ? '<div style="font-size:12px;color:#0F9D58;font-weight:700;margin-top:6px">Upscale to 300 dpi ✓</div>' : '');
    if (previewMsg && previewMsg.isConnected) previewMsg.innerHTML = html;
    else previewMsg = bot(html, true);
    var wrap = previewMsg.querySelector('[data-nodi-prep]');
    var img = wrap && wrap.querySelector('img');
    if (prepLabel && img) {
      var settle = function () { wrap.classList.remove('is-loading'); };
      if (img.complete && img.naturalWidth) setTimeout(settle, 350);
      else { img.addEventListener('load', settle); img.addEventListener('error', settle); }
      setTimeout(settle, 12000); /* never strand the veil */
    }
    scrollBottom();
  }
  function stagedChips() {
    var list = [
      { label: staged.bgRemove ? 'Undo background removal' : 'Remove background', go: function () {
          staged.bgRemove = !staged.bgRemove;
          save();
          showStagedPreview(staged.bgRemove ? 'Removing background…' : 'Restoring…');
          bot(staged.bgRemove ? 'Removing the background, free, and baked in when you order.' : 'Background restored.');
          stagedChips();
        } },
      { label: staged.upscale ? 'Undo upscale' : 'Upscale to 300 dpi', go: function () {
          staged.upscale = !staged.upscale;
          save();
          showStagedPreview(staged.upscale ? 'Upscaling to 300 dpi…' : 'Reverting…');
          bot(staged.upscale ? 'I’ll upscale it to 300 dpi when you order.' : 'Upscale removed.');
          stagedChips();
        } }
    ];
    if (IS_GANG) {
      list.push({ label: 'Order as DTF Gang Sheet', go: function () { placeStaged('dtf-gang'); } });
      list.push({ label: 'Order as UV DTF Gang Sheet', go: function () { placeStaged('uv-gang'); } });
    } else {
      /* a single uploaded image = a by-size order — gang sheets are only
         offered on the gang pages themselves (Justin 2026-07-27) */
      list.push({ label: 'Order as DTF', go: function () { placeStaged('dtf-size'); } });
      list.push({ label: 'Order as UV DTF', go: function () { placeStaged('uv-size'); } });
    }
    chips(list);
  }
  function stageFile(file, note) {
    var w = working('Prepping ' + file.name + '…');
    nodiPresign(file).then(function (imgixUrl) {
      w.done();
      staged = { file: file, imgix: imgixUrl, bgRemove: false, upscale: false };
      var t = (note || '').toLowerCase();
      if (/remove.*(background|bg)|transparent/.test(t)) staged.bgRemove = true;
      if (/upscale|300 ?dpi|sharpen|resolution/.test(t)) staged.upscale = true;
      previewMsg = null;
      save();
      showStagedPreview(staged.bgRemove ? 'Removing background…' : 'Rendering preview…');
      bot('Here’s your design' + (staged.bgRemove ? ' with the background removed' : '') +
        '. Touch it up, or tell me how you want it printed:');
      stagedChips();
    }).catch(function () {
      w.done();
      /* pipeline hiccup — fall back to the page's own uploader */
      bot('My staging table is jammed, sending it straight to this page’s uploader instead.');
      pipeFile(file);
    });
  }

  function targetUrl(ctx) {
    var map = {
      'dtf-size': '/products/dtf-transfers?view=dtf-imgix',
      'uv-size': '/products/uv-dtf-stickers?view=uv-by-size-imgix',
      'dtf-gang': '/products/dtf-gang-sheets?view=dtf-gang-imgix',
      'uv-gang': '/products/uv-dtf-gang-sheets?view=uv-gang-imgix'
    };
    return map[ctx];
  }
  function withPreview(url) {
    var params = new URLSearchParams(window.location.search);
    if (params.has('preview_theme_id')) url += (url.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + encodeURIComponent(params.get('preview_theme_id'));
    return url;
  }
  function placeStaged(target) {
    if (!staged) return;
    if (target === CTX && staged.file) {
      /* same product: feed the File into this page's engine, then apply edits */
      var st = staged;
      staged = null;
      bot('Perfect, setting up your order on this page…');
      pipeFile(st.file);
      if (st.bgRemove) waitUploadedThen(function () { artEdit('bgr'); });
      if (st.upscale && !IS_GANG) waitUploadedThen(function () { artEdit('sr'); });
      return;
    }
    /* other product: hand off via ?file= and carry the staged edits as
       flags, Nodi on the destination page flips its own toggles so the
       customer arrives with Remove background / Upscale already ON */
    var url = targetUrl(target) + '&file=' + encodeURIComponent(staged.imgix);
    if (staged.bgRemove) url += '&nodi_bgr=1';
    if (staged.upscale) url += '&nodi_sr=1';
    url = withPreview(url);
    bot('Taking you there with your design…');
    setTimeout(function () { window.location.href = url; }, 500);
  }
  function pipeFile(file) {
    var inp = pageFileInput();
    if (!inp) { bot('I couldn’t find the uploader on this page, use the upload box under the product title instead.'); return; }
    var pw = working('Uploading ' + file.name + '…');
    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      inp.files = dt.files;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {
      pw.done();
      bot('That didn’t take, drop your file on the page’s upload box instead.');
      return;
    }
    var t0 = Date.now();
    var iv = setInterval(function () {
      if (uploaded()) {
        clearInterval(iv);
        pw.done();
        refreshCart();
        if (IS_GANG) {
          bot('Uploaded! We auto-detected your sheet size. Check the price, tick the artwork-rights box, and you’re ready for checkout.');
          chips([
            { label: 'Show my sheet', go: function () { showEl('.gangSheet, .split_design', ''); } },
            { label: 'Back', go: home }
          ]);
        } else {
          bot('Uploaded! Your design is previewing at true print size. Want me to clean it up, or go straight to sizes?');
          chips([
            { label: 'Remove background', go: function () { artEdit('bgr'); } },
            { label: 'Upscale to 300 dpi', go: function () { artEdit('sr'); } },
            { label: 'Take me to sizes', go: function () { showEl('.bsv4-sizing__intro', ''); } },
            { label: 'Back', go: home }
          ]);
        }
      } else if (Date.now() - t0 > 90000) {
        clearInterval(iv);
        pw.done();
        bot('Still working… big files can take a moment. If nothing happens, try the upload box on the page or email <a href="mailto:service@dtftransfers.com">service@dtftransfers.com</a>.');
      }
    }, 600);
  }
  function uploadCard() {
    if (uploaded()) return;
    var el = document.createElement('div');
    el.className = 'nodi-upload';
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.innerHTML =
      '<span class="nodi-upload__icon">' + CLOUD + '</span>' +
      '<span class="nodi-upload__text">' +
        '<div class="nodi-upload__title">' + (IS_GANG ? 'Drop your gang sheet here' : 'Drop your artwork here') + '</div>' +
        '<div class="nodi-upload__sub">PNG, PDF, AI, PSD or SVG · 300 dpi</div>' +
      '</span>' +
      '<span class="nodi-upload__btn">Browse</span>';
    el.addEventListener('click', function () { nodiFile.click(); });
    el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); nodiFile.click(); } });
    el.addEventListener('dragover', function (e) { e.preventDefault(); el.classList.add('is-drag'); });
    el.addEventListener('dragleave', function () { el.classList.remove('is-drag'); });
    el.addEventListener('drop', function (e) {
      e.preventDefault();
      el.classList.remove('is-drag');
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) setPending(f);
    });
    body.appendChild(el);
    scrollBottom();
  }

  /* in-chat art edits — drive the page's own AI toggles/links */
  function artEdit(kind) {
    if (!uploaded()) { bot('Attach your artwork first (the paperclip below) and send, then I can edit it.'); return; }
    if (IS_GANG) {
      var link = Array.prototype.find.call(document.querySelectorAll('a,button,span'),
        function (e) { return /remove background/i.test(e.textContent) && e.children.length < 2 && e.offsetParent; });
      if (kind === 'bgr' && link) { link.click(); bot('On it, removing the background. Your preview will refresh in a moment.'); }
      else bot('That edit isn’t available on gang sheets, background removal is, right under your preview.');
      return;
    }
    var sel = kind === 'bgr' ? '[data-bsv4-toggle-bgr]' : '[data-bsv4-toggle-sr]';
    var box = document.querySelector('.bsv4-preview__tools ' + sel) || document.querySelector(sel);
    if (!box) { bot('I can’t reach that control right now, the toggles live under your preview in Step 1.'); return; }
    if (box.checked) { bot(kind === 'bgr' ? 'Background removal is already on ✓' : 'Upscaling is already on ✓'); return; }
    box.click();
    bot(kind === 'bgr'
      ? 'On it, removing the background. Free, and the preview updates in a few seconds.'
      : 'Upscaling to 300 dpi, free, and the preview updates in a few seconds.');
  }

  /* ---------- page actions ---------- */
  function showEl(sel, fallbackMsg) {
    var el = null;
    sel.split(',').some(function (s) {
      var cand = document.querySelector(s.trim());
      if (cand && getComputedStyle(cand).display !== 'none' && cand.getBoundingClientRect().height > 0) { el = cand; return true; }
      return false;
    });
    if (!el) { if (fallbackMsg) bot(fallbackMsg); return false; }
    el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    el.classList.add('nodi-highlight');
    setTimeout(function () { el.classList.remove('nodi-highlight'); }, 3400);
    return true;
  }
  var SEL_UPLOAD = IS_GANG ? '.dtfut, .upload-area__drop-zoon' : '.bsv4-uploader__zone, [data-bsv4-block="upload_box"]';
  var uploaded = function () { return IS_GANG ? document.body.classList.contains('image-uploaded') : !!document.querySelector('.bsv4[data-state="uploaded"]'); };

  /* ---------- live pricing (by-size: read the page's own tier card) ---------- */
  function readTiers() {
    var rows = document.querySelectorAll('.cdxc__tier');
    var tiers = [];
    rows.forEach ? rows.forEach(collect) : Array.prototype.forEach.call(rows, collect);
    function collect(r) {
      var t = r.textContent || '';
      var range = t.match(/(\d+)\s*(?:–|-)\s*(\d+)|(\d+)\+/);
      var price = t.match(/\$([\d.]+)/);
      var pct = t.match(/(\d+)%\s*off/);
      if (!range || !price) return;
      tiers.push({
        min: parseInt(range[1] || range[3], 10),
        max: range[2] ? parseInt(range[2], 10) : Infinity,
        unit: parseFloat(price[1]),
        pct: pct ? parseInt(pct[1], 10) : 0
      });
    }
    return tiers;
  }

  function pricingFlow() {
    if (!IS_PDP) {
      bot('Two ways to save:<br><br><b>By size</b>: per-piece tiers that are <b>cumulative across your whole order</b> (up to 50% off).<br><b>Gang sheets</b>: fill a 22″ sheet and pay by the sheet, up to <b>67% off</b> on the biggest sizes.<br><br>No minimums, no setup or art fees either way.');
      chips([
        { label: 'DTF by size', go: function () { window.location.href = withPreview('/products/dtf-transfers?view=dtf-imgix'); } },
        { label: 'Gang sheets', go: function () { window.location.href = withPreview('/products/dtf-gang-sheets?view=dtf-gang-imgix'); } }
      ]);
      return;
    }
    if (IS_GANG) {
      bot('Gang sheets are priced per sheet, all sheets are <b>22″ wide</b>, and the price depends on the length you pick (or that we auto-detect from your file). Bigger sheets = better $/sq in, up to <b>67% off</b> on the largest sizes.');
      bot('Upload your sheet and NODI’s teammates upstairs will auto-detect the height and show your exact price, or grab a template below the product details to build to an exact size.');
      chips([
        { label: 'Show me the upload box', go: function () { showEl(SEL_UPLOAD, 'Scroll to the top of the page, the upload box is right under the product title.'); } },
        { label: 'Where are the templates?', go: templatesFlow },
        { label: 'Back', go: home }
      ]);
      return;
    }
    var tiers = readTiers();
    if (!tiers.length) {
      bot('Pricing is per piece and drops as your order grows. The discounts are <b>cumulative across every transfer and sticker in your order</b>, not per design. The pricing card on this page shows every tier.');
      chips([{ label: 'Show me the pricing card', go: function () { showEl('.cdxc-host, .bsv4-pricing', 'Upload a design first and the pricing card appears beside the preview.'); } }, { label: 'Back', go: home }]);
      return;
    }
    var lines = tiers.map(function (t) {
      var range = t.max === Infinity ? t.min + '+' : t.min + '-' + t.max;
      return range + ' pieces → <b>$' + t.unit.toFixed(2) + '</b>' + (t.pct ? ' <span style="color:#0F9D58;font-weight:700">(' + t.pct + '% off)</span>' : '');
    });
    bot('Here’s the live per-piece pricing at your current size, and the discount counts <b>every piece in your whole order combined</b>:<br><br>' + lines.join('<br>'));
    bot('Change the size in Step 2 and these prices update automatically.');
    chips([
      { label: 'Show me the size table', go: function () { showEl('.bsv4-sizing__rows, .bsv4-sizing__intro', 'Upload a design first, then Step 2 lets you set sizes and quantities.'); } },
      { label: 'Back', go: home }
    ]);
  }

  /* ---------- flows ---------- */
  function orderFlow() {
    if (!IS_PDP) {
      bot('Attach your artwork (paperclip below) and I’ll prep it right here, then you pick how it prints: DTF transfers by size, UV DTF stickers, or a full gang sheet.');
      return;
    }
    if (IS_GANG) {
      bot('Easy, attach your finished 22″-wide sheet (paperclip below) and I’ll handle the upload. We auto-detect the size and price it instantly.');
    } else {
      bot('Easy, attach your art (paperclip below) and I’ll handle the upload. Then just pick sizes and check out. I can also remove the background or upscale it for you, free.');
    }
  }

  function templatesFlow() {
    bot('Template files for every sheet size (AI + PDF) live in the <b>Downloadable Templates</b> section under Product Details, each row also links straight into the Online Builder at that size.');
    chips([
      { label: 'Take me there', go: function () { showEl('.toggle__title, summary, [class*="accordion"]', ''); var acc = Array.prototype.find.call(document.querySelectorAll('summary,button,.accordion__title,[data-js-toggle]'), function (e) { return /Downloadable/i.test(e.textContent); }); if (acc) { acc.scrollIntoView({ block: 'center', behavior: 'smooth' }); setTimeout(function () { acc.click(); }, 600); } } },
      { label: 'Open the Online Builder', go: function () { window.location.href = '/products/' + (IS_UV ? 'uv-dtf-gang-sheet-builder' : 'dtf-gang-sheets-builder'); } },
      { label: 'Back', go: home }
    ]);
  }

  function productFlow() {
    if (IS_UV) {
      bot('<b>UV DTF</b> makes permanent, waterproof stickers for hard surfaces: tumblers, glass, coolers, laptops, vehicles. No heat press needed: peel and stick, and it holds up outdoors and in the wash.');
    } else {
      bot('<b>DTF transfers</b> are full-color heat-applied prints that work on cotton, blends, polyester. Practically any fabric, any color. Press at home or in production; vibrant 9-color printing is included on every order.');
    }
    bot('Every order ships from the USA, printed within 24 hours of your file hitting the press. No minimums, no setup or art fees.');
    chips([
      { label: 'I need print capacity', go: capacityFlow },
      { label: 'Start my own store', go: resellerEducationFlow },
      { label: 'Back', go: home }
    ]);
  }

  function resellerEducationFlow() {
    bot('Smart choice. <b>dtftransfers.com</b> gives you a complete DTF storefront without owning a printer:<br><br>' +
      '• Your own store and <b>.com domain, free</b><br>' +
      '• You brand it and <b>set your own prices</b><br>' +
      '• We <b>print and blind-ship from the USA</b>. Your customers only ever see your brand<br>' +
      '• No film, no stock, no minimums, one piece to thousands, on demand<br>' +
      '• <b>Customer service built in</b>: your buyers file issues right on your store, reprints are a couple of clicks, and returns are handled end to end inside the software');
    resellerCard();
    chips([
      { label: 'What can I earn?', go: marginFlow },
      { label: 'How do I get started?', go: function () {
          bot('Three steps, and most resellers are <b>live the same day</b>:<br><br><b>1.</b> <a href="https://sell.dtftransfers.com/#signup" target="_blank" rel="noopener">Request your account</a>, takes a minute.<br><b>2.</b> Brand your store: name, logo, colors, your own .com domain.<br><b>3.</b> Set your prices and share your link. We print, blind-ship, and handle customer service and reprints inside your store’s software.');
          chips([{ label: 'Learn more', go: function () { window.location.href = SITE + '/pages/storefronts'; } }, { label: 'Request my account', go: function () { window.open('https://sell.dtftransfers.com/#signup', '_blank'); } }]);
        } },
      { label: 'I need print capacity', go: capacityFlow }
    ]);
  }

  function resellerFlow() {
    bot('Printing for clients, or want to? You can run your <b>own DTF storefront</b> powered by our production.');
    resellerCard();
    chips([{ label: 'Back', go: home }]);
  }

  function home() {
    // no direct selling on dtftransfers.com any more (Justin 2026-07-31): the two paths ARE the
    // product, so the chips are capacity / storefront / education - never "order here"
    var list = [
      { label: 'I need print capacity', go: capacityFlow },
      { label: 'Start my own store', go: resellerEducationFlow },
      { label: 'What is ' + (IS_UV ? 'UV DTF' : 'DTF') + '?', go: productFlow }
    ];
    chips(list);
  }


  /* ---------- knowledge base ----------
     Compiled 2026-07-27 from the store's own product knowledge (accordions:
     Features / Pressing / Application / Shipping & Returns / Art Upload
     Recommendations) + the sell.dtftransfers.com public landing, i.e. the
     same substance NinjaForce feeds the NT-side agent, filtered to what is
     true for dtftransfers.com and for LOGGED-OUT sell.dtftransfers.com
     visitors. No portal/account knowledge lives here. */
  var KB = [
    { ctx: 'dtf', k: ['press', 'pressing', 'iron', 'heat', 'temperature', 'temp', 'seconds', 'peel', 'apply', 'application'],
      a: 'Pressing is four quick steps:<br><br><b>1.</b> No pre-press needed, only pre-iron if you prefer it.<br><b>2.</b> Position the transfer flat where you want it (seams are fine; heat-tape helps on hats).<br><b>3.</b> Press at <b>310°F / 155°C</b>, medium-to-high pressure, about <b>12 seconds</b>, use parchment or a platen cover, wait a few seconds, then peel.<br><b>4.</b> Cover and give it a short <b>5-10 second</b> second press to lock in wash durability.<br><br>New fabric? Run one small test press first.' },
    { ctx: 'uv', k: ['apply', 'application', 'stick', 'sticker', 'squeegee', 'install', 'put on'],
      a: 'UV DTF applies with no heat press:<br><br><b>1.</b> Clean the surface: soap and water or a 50/50 rubbing-alcohol mix.<br><b>2.</b> Squeegee the sticker while it’s still on the backing.<br><b>3.</b> Peel, place, and press it down firmly.<br><b>4.</b> Peel the top film away slowly.<br><br>A clean surface is what keeps it on through weather and washes.' },
    { k: ['surface', 'tumbler', 'cup', 'glass', 'laptop', 'car', 'window', 'outdoor', 'waterproof', 'weather'],
      a: 'UV DTF stickers bond to hard, smooth surfaces: tumblers, glass, laptops, coolers, car windows. They’re built for weather and washing. For <b>fabric</b>, you want regular DTF transfers instead.' },
    { k: ['fabric', 'cotton', 'polyester', 'blend', 'garment', 'shirt', 'hoodie', 'material'],
      a: 'DTF transfers press onto practically any fabric and any color, cotton, blends, polyester, canvas, denim. One transfer type covers your whole line; no color-count or garment restrictions.' },
    { k: ['file', 'format', 'dpi', 'resolution', 'vector', 'png', 'transparent', 'color profile', 'rgb', 'artwork requirements'],
      a: 'We accept every common file type. Vector art (AI, PDF, SVG) gives the cleanest results; raster files should be <b>300 DPI or higher</b> with a transparent background. For truest color, design in the <b>Adobe RGB (1998)</b> profile. Gang sheets should be built <b>22″ wide</b>.' },
    { k: ['quality', 'colors', 'vivid', 'bright', 'white ink', '9 color', '9-color'],
      a: 'Every order runs our High Color process, an expanded <b>CMYK + RGBO + White</b> ink set (16.7 million printable colors) for brighter whites, deeper saturation, smoother gradients, and sharper detail. 9-color printing is included at <b>no upcharge</b>.' },
    { k: ['ship', 'shipping', 'deliver', 'delivery', 'turnaround', 'how long', 'fast', 'when will', 'tracking', 'express', 'canada'],
      a: 'Orders come off the printers within <b>24 hours</b>. Transfer & supply orders over <b>$75 ship free</b> in the US (Canada free at $99+), and express options as fast as <b>1 business day</b> are available at checkout. Tracking hits your email as soon as the label prints.' },
    { k: ['return', 'refund', 'reprint', 'guarantee', 'wrong', 'mistake', 'damaged', 'quality issue'],
      a: 'Every print is backed by our satisfaction guarantee: if something isn’t right, we’ll <b>reprint your order free</b> with a new or corrected file. Reach the team at <a href="mailto:service@dtftransfers.com">service@dtftransfers.com</a> and they’ll sort it out.' },
    { k: ['wash', 'washing', 'laundry', 'durab', 'last', 'crack', 'fade', 'care'],
      a: 'Pressed correctly, our transfers are certified for <b>100+ washes</b>. Care tips: wash cold inside-out, tumble dry low, skip bleach, and don’t iron directly on the print. The short second press after peeling is what locks in durability.' },
    { k: ['gang sheet', 'gang', '22', 'sheet size', 'auto detect', 'detect'],
      a: 'Gang sheets are <b>22″ wide</b>: fill one with as many designs as fit and pay by the sheet. Upload a finished sheet and we <b>auto-detect the height</b> and price it instantly; sized templates (AI/PDF) and our Online Builder are under Product Details. Bigger sheets run up to <b>67% off</b> per square inch.' },
    { k: ['discount', 'bulk', 'cumulative', 'tier', 'cheaper', 'wholesale', 'price', 'pricing', 'cost'],
      a: 'Pricing runs through our reseller platform: capacity accounts see wholesale pricing after a free signup, and store owners set their own retail on top. Take a look at <a href="/pages/capacity">capacity</a> or <a href="/pages/storefronts">storefronts</a> to see which fits you.' },
    { k: ['pre-cut', 'precut', 'pre cut', 'cutting'],
      a: 'Add <b>pre-cutting</b> in Final Touches and your transfers arrive individually cut, ready to press straight out of the box. Big time-saver on multi-piece orders.' },
    { k: ['minimum', 'setup fee', 'art fee', 'how many', 'one piece', 'small order'],
      a: 'No minimums, no setup fees, no art fees. Order <b>one piece or a thousand</b> at the same quality.' },
    { k: ['sample', 'test order', 'try'],
      a: 'The best way to see the quality is through your own account: capacity accounts can send a small overflow job, and store owners get the same production on every order. Start free at <a href="https://sell.dtftransfers.com/#signup">sell.dtftransfers.com</a>.' },
    { k: ['sell', 'reseller', 'resell', 'own store', 'storefront', 'white label', 'blind ship', 'start a business', 'my own brand', 'dropship'],
      a: '<b>dtftransfers.com</b> lets you launch a print business without the printer: your own storefront and .com domain <b>free</b>, you brand it and set your prices, and we <b>print and blind-ship from the USA</b>. Your customers only ever see your brand. No printer, no film, no stock; order from one piece to thousands. Sign-up takes minutes and most resellers are live the same day.', card: true },
    { k: ['contact', 'human', 'support', 'phone', 'email', 'talk to'],
      a: 'The team’s at <a href="mailto:service@dtftransfers.com">service@dtftransfers.com</a> or <b>888-846-0221</b>. 2905 Southampton Road, Philadelphia PA.' },
    { k: ['what is dtf', 'dtf mean', 'direct to film', 'dtf vs', 'screen print', 'sublimation', 'dtg'],
      a: '<b>DTF (direct-to-film)</b> prints your design on film with adhesive powder, and you heat-press it onto the garment. Unlike sublimation it works on <b>any fabric and any color</b>, and unlike screen printing there are <b>no setup fees or color limits</b>, full-color one-offs cost the same per piece as repeats.' }
  ];

  function kbMatch(text) {
    var t = ' ' + text.toLowerCase() + ' ';
    var best = null, bestScore = 0;
    for (var i = 0; i < KB.length; i++) {
      var e = KB[i];
      var score = 0;
      for (var j = 0; j < e.k.length; j++) {
        if (t.indexOf(e.k[j]) > -1) score += e.k[j].length > 4 ? 2 : 1;
      }
      if (e.ctx && ((e.ctx === 'uv') === IS_UV)) score += 1;       /* prefer this page's variant */
      if (e.ctx && ((e.ctx === 'uv') !== IS_UV) && score) score -= 1;
      if (score > bestScore) { bestScore = score; best = e; }
    }
    return bestScore >= 2 ? best : null;
  }

  /* ---------- typed input: page actions stay LOCAL, knowledge goes to the SHARED BRAIN ----------
     Page actions (ordering, uploads, templates, live pricing, the reseller card) drive THIS page's
     own controls, so they must not leave it. Everything else posts to /dtf-nodi on the shared Nodi
     lambda, the same brain behind the portal and every reseller storefront: one knowledge-table
     write updates all three channels, and the guardrails (no em dashes, no emoji, no invented
     specs) are enforced server-side in one place. The old keyword router survives untouched as
     cannedFallback(), so a dead network degrades to exactly yesterday's behaviour. */
  function route(text) {
    var t = text.toLowerCase();
    if (window.NODI_BACKEND && typeof window.NODI_BACKEND.send === 'function') {
      var typing = mkTyping();
      window.NODI_BACKEND.send(text).then(function (html) { typing.remove(); bot(html); home(); })
        .catch(function () { typing.remove(); bot('Hmm, I couldn’t reach base. Try one of these instead:'); home(); });
      return;
    }
    if (/margin|markup|(store|storefront|sell).{0,24}(pric|profit|earn|make money)|how much (do|can|would) i (make|earn|keep)/.test(t)) return marginFlow();
    if (/sell|resell|reseller|own store|storefront|white label|brand/.test(t)) return resellerFlow();
    /* pricing deliberately NOT handled locally any more: dtftransfers.com shows no public
       pricing (Justin 2026-07-31), so pricing questions go to the shared brain, which routes
       them to capacity or storefronts. */
    if (/template|builder|\bai file|artboard/.test(t)) return IS_GANG ? templatesFlow() : orderFlow();
    if (/order|upload|start|size|sizing|qty|quantity|how do i|checkout|buy/.test(t)) return orderFlow();
    askBrain(text);
  }

  function mkTyping() {
    var typing = document.createElement('div');
    typing.className = 'nodi-typing';
    typing.textContent = 'NODI is thinking…';
    body.appendChild(typing);
    scrollBottom();
    return typing;
  }

  /* history for the LLM: the last few turns out of the persisted log, tags stripped */
  function brainHistory() {
    var out = [];
    log.slice(-8).forEach(function (m) {
      if (m.r === 'user' && m.t) out.push({ role: 'user', text: m.t });
      if (m.r === 'bot' && m.h) out.push({ role: 'assistant', text: String(m.h).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim() });
    });
    return out;
  }

  /* LLM reply -> safe HTML: escape everything first, then re-allow ONLY markdown links to our own
     relative paths or sell.dtftransfers.com, plus **bold**. The [[quick: ...]] line becomes chips. */
  function brainRender(raw) {
    var quick = null;
    var m = raw.match(/\[\[quick:([^\]]+)\]\]/i);
    if (m) {
      quick = m[1].split('|').map(function (x) { return x.trim(); }).filter(Boolean).slice(0, 4);
      raw = raw.replace(m[0], '').trim();
    }
    if (SITE) raw = raw.replace(/\]\(\//g, '](' + SITE + '/'); // offsite: absolutize the model's relative links
    var h = esc(raw)
      .replace(/\[([^\]]+)\]\((https:\/\/sell\.dtftransfers\.com[^\s)]*|\/[^\s)]+)\)/g, '<a href="$2">$1</a>')
      .replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>')
      .replace(/\n{2,}/g, '<br><br>').replace(/\n/g, '<br>');
    return { h: h, quick: quick };
  }

  function askBrain(text) {
    var typing = mkTyping();
    var payload = { message: text, page: PRODUCT_NAME, history: brainHistory() };
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var tmr = ctl && setTimeout(function () { ctl.abort(); }, 12000);
    fetch(NODI_API + '/dtf-nodi', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload), signal: ctl ? ctl.signal : undefined,
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (tmr) clearTimeout(tmr);
        typing.remove();
        if (!j || !j.ok || !j.reply) { cannedFallback(text); return; }
        var out = brainRender(j.reply);
        bot(out.h);
        if (out.quick && out.quick.length) {
          chips(out.quick.map(function (q) { return { label: q, go: function () { route(q); } }; }));
        } else { home(); }
      })
      .catch(function () { if (tmr) clearTimeout(tmr); typing.remove(); cannedFallback(text); });
  }

  /* offline / error fallback: yesterday's keyword router, verbatim */
  function cannedFallback(text) {
    var t = text.toLowerCase();
    var hit = kbMatch(text);
    if (hit) {
      bot(hit.a);
      if (hit.card) resellerCard();
      home();
      return;
    }
    if (/what is|uv dtf|dtf|apply|press|wash|durab|material|fabric|surface/.test(t)) return productFlow();
    if (/ship|deliver|turnaround|how long|fast/.test(t)) {
      bot('Orders come off the printers within <b>24 hours</b> and ship free from the USA. You’ll get tracking by email the moment the label prints.');
      return home();
    }
    if (/help|human|support|contact|phone|email/.test(t)) {
      bot('Sometimes you just want a human! Reach the team at <a href="mailto:service@dtftransfers.com">service@dtftransfers.com</a> or <b>888-846-0221</b>.');
      return home();
    }
    bot('I can help you pick your path. Choose one of these, or email <a href="mailto:service@dtftransfers.com">service@dtftransfers.com</a> for anything else.');
    home();
  }

  function submit() {
    var text = input.value.trim();
    if (!text && !pendingFile) return;
    input.value = '';
    if (pendingFile) {
      var f = pendingFile;
      clearPending();
      user((text ? text + '  ' : '') + 'Attached: ' + f.name);
      stageFile(f, text);
      return;
    }
    user(text);
    var tl = text.toLowerCase();
    if (/remove.*(background|bg)\b|make.*transparent/.test(tl)) { artEdit('bgr'); return; }
    if (/upscale|300 ?dpi|sharpen|low res|resolution/.test(tl)) { artEdit('sr'); return; }
    route(text);
  }
  function waitUploadedThen(fn) {
    var t0 = Date.now();
    var iv = setInterval(function () {
      if (uploaded()) { clearInterval(iv); setTimeout(fn, 800); }
      else if (Date.now() - t0 > 90000) clearInterval(iv);
    }, 600);
  }

  /* the standard opening: who Nodi is, then the reseller/order fork.
     Used on first open AND after a confirmed "New chat". */
  function capacityFlow() {
    bot('If you already print DTF, we become your overflow room: hand off the work you can’t get to and we print and blind-ship it under your label at wholesale prices. No minimums, no night shift.');
    capacityCard();
    chips([
      { label: 'How does pricing work?', go: function () { askBrain('How does capacity pricing work?'); } },
      { label: 'Start my own store', go: resellerEducationFlow }
    ]);
  }

  function greetIntro() {
    bot('Hey! I’m <b>Nodi</b>, the DTF Transfers assistant. We power your printing business two ways: hand us your overflow production at wholesale, or launch your own DTF storefront that we print and blind-ship for you. Which fits you?');
    chips([
      { label: 'I need print capacity', go: capacityFlow },
      { label: 'Start my own store', go: resellerEducationFlow }
    ]);
  }

  /* ---------- restore an in-flight conversation ---------- */
  function renderSaved(d) {
    restoring = true;
    body.innerHTML = '';
    previewMsg = null;
    log = d.log.slice();
    log.forEach(function (m) {
      if (m.r === 'user') user(m.t);
      else if (m.r === 'card') resellerCard();
      else if (m.r === 'ccap') capacityCard();
      else if (m.r === 'pcalc') pricingCard();
      else bot(m.h);
    });
    staged = d.staged ? { file: null, imgix: d.staged.imgix, bgRemove: !!d.staged.bgRemove, upscale: !!d.staged.upscale } : null;
    restoring = false;
    if (staged) { showStagedPreview(); stagedChips(); }
    // ALWAYS leave a pill row under a restored transcript (Justin 2026-07-31): chips are never
    // persisted in the log, so a restore used to end with no tappable options at all - the exact
    // "greeting with nothing under it" screenshot. A staged file keeps its own chip row instead.
    else home();
    greeted = true;
  }
  var savedOnBoot = readSaved();

  /* another tab in this session moved the conversation forward */
  window.addEventListener('storage', function (e) {
    if (e.key !== LS_KEY) return;
    if (!e.newValue) { clearSaved(); body.innerHTML = ''; greeted = false; return; }
    var d = readSaved();
    if (d) renderSaved(d);
  });

  /* ---------- carried edits: arriving from a cross-page handoff ---------- */
  (function applyCarriedEdits() {
    if (!IS_PDP) return;
    var params = new URLSearchParams(window.location.search);
    var wantBgr = params.get('nodi_bgr') === '1';
    var wantSr = params.get('nodi_sr') === '1' && !IS_GANG;
    if (!wantBgr && !wantSr) return;
    waitUploadedThen(function () {
      document.body.classList.add('nodi-open');
      if (!greeted && savedOnBoot) { renderSaved(savedOnBoot); savedOnBoot = null; }
      if (!greeted) {
        greeted = true;
        bot('Your design made it over with your edits:');
      }
      if (wantBgr) artEdit('bgr');
      if (wantSr) setTimeout(function () { artEdit('sr'); }, wantBgr ? 1200 : 0);
      refreshCart();
    });
  })();

  /* ---------- wiring ---------- */
  var greeted = false;
  launcher.addEventListener('click', function () {
    if (document.body.classList.contains('nodi-open')) { closePanel(); return; }
    document.body.classList.add('nodi-open');
    refreshCart();
    try { panel.querySelector('[data-nodi-cart-link]').href = withPreview('/cart'); } catch (e) {}
    if (!greeted && savedOnBoot) {
      renderSaved(savedOnBoot);
      savedOnBoot = null;
    } else if (!greeted) {
      greeted = true;
      /* conversion-first welcome, per page (chips live in the ⊞ menu now) */
      greetIntro();
    }
    setTimeout(function () { input.focus(); }, 150);
  });
  function closePanel() { document.body.classList.remove('nodi-open'); }
  panel.querySelector('[data-nodi-close]').addEventListener('click', closePanel);
  panel.querySelector('[data-nodi-min]').addEventListener('click', closePanel);
  panel.querySelector('[data-nodi-max]').addEventListener('click', function () {
    panel.classList.toggle('is-max');
  });
  function doNewChat() {
    clearSaved();
    body.innerHTML = '';
    clearPending();
    greeted = true;
    greetIntro();   /* straight back to the normal start of the flow */
  }
  var newPop = panel.querySelector('[data-nodi-newpop]');
  var newPopBody = panel.querySelector('[data-nodi-newpop-body]');
  panel.querySelector('[data-nodi-new]').addEventListener('click', function (e) {
    e.stopPropagation();
    /* nothing worth losing yet — just reset */
    if (!log.length && !staged && !pendingFile) { doNewChat(); return; }
    newPopBody.innerHTML = 'This erases the current conversation' +
      (staged ? ', your uploaded design and any edits' : '') +
      ' and can’t be undone. Your cart isn’t affected.';
    newPop.classList.add('is-open');
  });
  panel.querySelector('[data-nodi-newpop-go]').addEventListener('click', function () {
    newPop.classList.remove('is-open');
    doNewChat();
  });
  panel.querySelector('[data-nodi-newpop-cancel]').addEventListener('click', function () {
    newPop.classList.remove('is-open');
  });
  document.addEventListener('click', function (e) {
    if (newPop.classList.contains('is-open') && !newPop.contains(e.target)) newPop.classList.remove('is-open');
  });
  var qm = panel.querySelector('[data-nodi-quickmenu]');
  function buildQuickMenu() {
    var items = [
      { icon: PEN, label: 'I need print capacity', go: capacityFlow },
      { icon: BAG, label: 'Start my own store', go: resellerEducationFlow },
      { icon: EXPAND, label: 'What is ' + (IS_UV ? 'UV DTF' : 'DTF') + '?', go: productFlow }
    ];
    qm.innerHTML = '';
    items.forEach(function (it) {
      var b = document.createElement('button');
      b.type = 'button';
      b.innerHTML = it.icon + '<span>' + it.label + '</span>';
      b.addEventListener('click', function () { qm.classList.remove('is-open'); user(it.label); it.go(); });
      qm.appendChild(b);
    });
  }
  panel.querySelector('[data-nodi-quick]').addEventListener('click', function (e) {
    e.stopPropagation();
    if (!qm.classList.contains('is-open')) buildQuickMenu();
    qm.classList.toggle('is-open');
  });
  document.addEventListener('click', function (e) {
    if (qm.classList.contains('is-open') && !qm.contains(e.target)) qm.classList.remove('is-open');
  });
  panel.querySelector('[data-nodi-attach]').addEventListener('click', function () { nodiFile.click(); });
  panel.querySelector('[data-nodi-send]').addEventListener('click', submit);
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter') submit(); });
})();
